import { render, staticRenderFns } from "./HxCurrent.vue?vue&type=template&id=6c1394a1&scoped=true&"
import script from "./HxCurrent.vue?vue&type=script&lang=js&"
export * from "./HxCurrent.vue?vue&type=script&lang=js&"
import style0 from "./HxCurrent.vue?vue&type=style&index=0&id=6c1394a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1394a1",
  null
  
)

export default component.exports